// Angular imports
import { Injectable, EventEmitter } from '@angular/core';

// Import observables
import { Observable } from 'rxjs';

// Define types
export type MessageOptions = {
    title: string;
    message: string;
    type?: MessageType;
    buttons?: ButtonHandler[];
    closeHandler?: () => void;
};

export enum MessageType {
    Warning = 'warning', 
    Error = 'error', 
    Info = 'info'
}

export type ButtonHandler = {
    text: string,
    handler?: () => void | boolean | Promise<void> | Promise<boolean>;
};

@Injectable({
    providedIn: 'root'
})
export class MessageService {
    // Event emitter for message container component to trigger show and hide
    private _requestMessageShowEmitter = new EventEmitter<MessageOptions>();
    private _requestMessageHideEmitter = new EventEmitter<void>();

    public get _requestMessageShow(): Observable<MessageOptions> {
        return this._requestMessageShowEmitter;
    }

    public get _requestMessageHide(): Observable<void> {
        return this._requestMessageHideEmitter;
    }

    // Publically readonly
    public get isMessagebeingShown(): boolean {
        return this._isMessageBeingShown;
    }
    private _isMessageBeingShown: boolean = false;

    constructor() { }

    public show(options: MessageOptions): boolean {
        // Check if a message is already being shown
        if (this._isMessageBeingShown) return false;

        // Trigger show event for message container component
        this._requestMessageShowEmitter.emit(options);

        // Set message as being shown
        this._isMessageBeingShown = true;
        return true;
    }

    public hide(): boolean {
        // Make sure a message is being shown
        if (!this._isMessageBeingShown) return false;

        // Trigger hide event for message container component
        this._requestMessageHideEmitter.emit();

        // Set message as hidden
        this._isMessageBeingShown = false;
        return true;
    }
}
